/**
 * 已註冊者點瓦斯行序號連結 `/register/step2/inviteCode?invite=<序號>` 時的導向決策純函式。
 *
 * 背景：舊行為在 LineLoginProvider.handleAppLogin 的 isRegister 分支，任何 /register/*
 * 頁只要 /line/login 回 200（代表已註冊）就一律用後端回的 redirectUrl 送回 LINE OA chat，
 * URL 帶的序號沒有任何地方接手，使用者看起來像被踢回首頁、序號整個丟掉（死路）。
 *
 * 新行為：這個特定入口改導去「新增瓦斯帳戶 → 輸入序號」流程（/account/addAccount）並帶入
 * 序號預填，讓使用者按確認送出（不自動送出）。未註冊者（401）不受影響，維持原 /register
 * 序號註冊流程。
 *
 * 副作用（navigate）留在 LineLoginProvider，這裡只做可測的判斷。
 */

/** 序號連結固定的落地頁路徑。 */
const SERIAL_INVITE_PATHNAME = "/register/step2/inviteCode";

/**
 * 只認「本次 URL」帶的 invite —— 不比照 InvitedCode 的 URL/sessionStorage/Cookie
 * 三來源攜帶機制，避免舊連結留在同一分頁的殘值誤觸發（比照 entry-check 的原則，
 * 見 parseOaEntryFromSearch）。
 *
 * 客戶序號後端字元集為純數字（OTPInputBlocks 於 InvitedCode／JoinSerial 皆未開
 * alphanumeric，預設只收 0-9），故淨化規則與家庭邀請碼（A-Z2-9）不同。
 */
export const parseSerialFromSearch = (search: string): string | null => {
  const params = new URLSearchParams(search);
  const raw = (params.get("invite") ?? "").replace(/[^0-9]/g, "").slice(0, 6);
  return raw || null;
};

/**
 * 已註冊者落在序號連結、且本次 URL 帶著序號 → 回傳 addAccount 序號預填深連結；
 * 其餘情況回 null，呼叫端維持既有的 redirectUrl 行為（送回 OA chat）。
 */
export const resolveSerialLinkRegisteredRedirect = (
  pathname: string,
  search: string,
): string | null => {
  if (pathname !== SERIAL_INVITE_PATHNAME) return null;
  const serial = parseSerialFromSearch(search);
  if (!serial) return null;
  return `/account/addAccount?serial=${serial}`;
};
